module.exports = __webpack_public_path__ + "static/media/study220510.60cd33a1.png";